import { IFetchHelper } from '@/interfaces/helper/IFetchHelper';
import type { RequestInit, Response } from 'node-fetch';
import fetch from 'node-fetch';
import opentelemetry, { SpanKind, Tracer } from '@opentelemetry/api';
import http, { RequestOptions } from 'http';
import * as https from 'https';

const TRACER_NAME = 'FetchHelper';

const httpAgent = new http.Agent({
  keepAlive: false,
});
const httpsAgent = new https.Agent({
  keepAlive: false,
});

export class FetchHelper implements IFetchHelper {
  constructor(private readonly _tracer: Tracer = opentelemetry.trace.getTracer(TRACER_NAME)) {
    this.agent = this.agent.bind(this);
  }

  agent(parsedUrl: URL): RequestOptions['agent'] {
    return parsedUrl.protocol === 'https:' ? httpsAgent : httpAgent;
  }

  async fetch(url: string, options: RequestInit = {}): Promise<Response> {
    const method = options.method || 'GET';
    const span = this._tracer.startSpan(`FETCH ${method} ${url}`, { kind: SpanKind.CLIENT });
    try {
      return await fetch(url, {
        ...options,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        agent: this.agent as any, // Different versions of typescript mess with the type of agent
        headers: {
          ...(options.headers || {}),
          'nx-app-id': 'bruntwood',
        },
      });
    } catch (err: unknown) {
      const error = err as Error & { code?: string };
      span.recordException({
        message: error.message,
        name: typeof error.name === 'string' ? error.name : 'Error',
        stack: error.stack,
        code: error?.code,
      });
      throw error;
    } finally {
      span.end();
    }
  }
}
